import { put, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../config/axios';
import { apiEndpoints } from '../../utils/api-endpoints';
import { createErrorAction } from '../reducers/errorSlice';
import {
  getAllTheaters,
  getAllTheatersSuccess,
  getTheaterById,
  getTheaterByIdSuccess,
  createTheater,
  createTheaterSuccess,
  updateTheater,
  updateTheaterSuccess,
  deleteTheater,
  deleteTheaterSuccess,
  getTheatersByLocation,
  getTheatersByLocationSuccess,
  getTheaterByName,
  getTheaterByNameSuccess,
} from '../reducers/theaterSlice';
import { getAllTheatersFailed, getTheaterByIdFailed, createTheaterFailed, updateTheaterFailed, deleteTheaterFailed, getTheatersByLocationFailed, getTheaterByNameFailed } from '../reducers/theaterSlice';
import { getErrorMessage } from '../../utils/helper.utils';

// Worker Sagas
function* getAllTheatersWorker(): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.get(apiEndpoints.theater.all);
    yield put(getAllTheatersSuccess(response.data));
  } catch (error: any) {
    yield put(getAllTheatersFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/getAllTheaters'));
  }
}

function* getTheaterByIdWorker(action: ReturnType<typeof getTheaterById>): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.get(apiEndpoints.theater.byId(action.payload as any));
    yield put(getTheaterByIdSuccess(response.data));
  } catch (error: any) {
    yield put(getTheaterByIdFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/getTheaterById'));
  }
}

function* createTheaterWorker(action: ReturnType<typeof createTheater>): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.post(apiEndpoints.theater.create, action.payload);
    yield put(createTheaterSuccess(response.data));
  } catch (error: any) {
    yield put(createTheaterFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/createTheater'));
  }
}

function* updateTheaterWorker(action: ReturnType<typeof updateTheater>): Generator<any, void, any> {
  try {
    const { id, theater } = action.payload as any;
    const response = yield axiosInstance.put(apiEndpoints.theater.byId(id), theater);
    yield put(updateTheaterSuccess(response.data));
  } catch (error: any) {
    yield put(updateTheaterFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/updateTheater'));
  }
}

function* deleteTheaterWorker(action: ReturnType<typeof deleteTheater>): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.delete(apiEndpoints.theater.byId(action.payload as any));
    yield put(deleteTheaterSuccess(response.data));
  } catch (error: any) {
    yield put(deleteTheaterFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/deleteTheater'));
  }
}

function* getTheatersByLocationWorker(action: ReturnType<typeof getTheatersByLocation>): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.get(apiEndpoints.theater.byLocation(action.payload as any));
    yield put(getTheatersByLocationSuccess(response.data));
  } catch (error: any) {
    yield put(getTheatersByLocationFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/getTheatersByLocation'));
  }
}

function* getTheaterByNameWorker(action: ReturnType<typeof getTheaterByName>): Generator<any, void, any> {
  try {
    const response = yield axiosInstance.get(apiEndpoints.theater.byName(action.payload as any));
    yield put(getTheaterByNameSuccess(response.data));
  } catch (error: any) {
    yield put(getTheaterByNameFailed(getErrorMessage(error)));
    yield put(createErrorAction(error, 'theater/getTheaterByName'));
  }
}

// Watcher Saga
export function* watchTheaterSaga(): Generator<any, void, any> {
  yield takeLatest(getAllTheaters.type, getAllTheatersWorker);
  yield takeLatest(getTheaterById.type, getTheaterByIdWorker);
  yield takeLatest(createTheater.type, createTheaterWorker);
  yield takeLatest(updateTheater.type, updateTheaterWorker);
  yield takeLatest(deleteTheater.type, deleteTheaterWorker);
  yield takeLatest(getTheatersByLocation.type, getTheatersByLocationWorker);
  yield takeLatest(getTheaterByName.type, getTheaterByNameWorker);
} 